const Role = {
    mmpladmin: 'admin',
    client: 'client',
    mmpl: 'mmpl',
    staff: 'staff',
    consultant:'consultant'
}
export default Role;